"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebLoginHeaderFromBrowser = exports.WebLoginHeader = void 0;
/* eslint-disable */
const geo_1 = require("../../core/geo");
const minimal_1 = __importDefault(require("protobufjs/minimal"));
function createBaseWebLoginHeader() {
    return {
        clientCookieId: "",
        webClientId: "",
        userAgent: "",
        device: "",
        os: "",
        browser: "",
        ipAddress: "",
        geoHeader: undefined,
        authenticationSessionPayload: new Uint8Array(),
        networkRequestId: "",
        arkoseToken: "",
        ssoClientId: "",
        continueParam: "",
    };
}
exports.WebLoginHeader = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.clientCookieId !== "") {
            writer.uint32(10).string(message.clientCookieId);
        }
        if (message.webClientId !== "") {
            writer.uint32(18).string(message.webClientId);
        }
        if (message.userAgent !== "") {
            writer.uint32(26).string(message.userAgent);
        }
        if (message.device !== "") {
            writer.uint32(34).string(message.device);
        }
        if (message.os !== "") {
            writer.uint32(42).string(message.os);
        }
        if (message.browser !== "") {
            writer.uint32(50).string(message.browser);
        }
        if (message.ipAddress !== "") {
            writer.uint32(58).string(message.ipAddress);
        }
        if (message.geoHeader !== undefined) {
            geo_1.GeoHeader.encode(message.geoHeader, writer.uint32(66).fork()).ldelim();
        }
        if (message.authenticationSessionPayload.length !== 0) {
            writer.uint32(74).bytes(message.authenticationSessionPayload);
        }
        if (message.networkRequestId !== "") {
            writer.uint32(82).string(message.networkRequestId);
        }
        if (message.arkoseToken !== "") {
            writer.uint32(90).string(message.arkoseToken);
        }
        if (message.ssoClientId !== "") {
            writer.uint32(98).string(message.ssoClientId);
        }
        if (message.continueParam !== "") {
            writer.uint32(106).string(message.continueParam);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWebLoginHeader();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.clientCookieId = reader.string();
                    break;
                case 2:
                    message.webClientId = reader.string();
                    break;
                case 3:
                    message.userAgent = reader.string();
                    break;
                case 4:
                    message.device = reader.string();
                    break;
                case 5:
                    message.os = reader.string();
                    break;
                case 6:
                    message.browser = reader.string();
                    break;
                case 7:
                    message.ipAddress = reader.string();
                    break;
                case 8:
                    message.geoHeader = geo_1.GeoHeader.decode(reader, reader.uint32());
                    break;
                case 9:
                    message.authenticationSessionPayload = reader.bytes();
                    break;
                case 10:
                    message.networkRequestId = reader.string();
                    break;
                case 11:
                    message.arkoseToken = reader.string();
                    break;
                case 12:
                    message.ssoClientId = reader.string();
                    break;
                case 13:
                    message.continueParam = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseWebLoginHeader();
        message.clientCookieId = object.clientCookieId ?? "";
        message.webClientId = object.webClientId ?? "";
        message.userAgent = object.userAgent ?? "";
        message.device = object.device ?? "";
        message.os = object.os ?? "";
        message.browser = object.browser ?? "";
        message.ipAddress = object.ipAddress ?? "";
        message.geoHeader =
            object.geoHeader !== undefined && object.geoHeader !== null
                ? geo_1.GeoHeader.fromPartial(object.geoHeader)
                : undefined;
        message.authenticationSessionPayload =
            object.authenticationSessionPayload ?? new Uint8Array();
        message.networkRequestId = object.networkRequestId ?? "";
        message.arkoseToken = object.arkoseToken ?? "";
        message.ssoClientId = object.ssoClientId ?? "";
        message.continueParam = object.continueParam ?? "";
        return message;
    },
};
function createBaseWebLoginHeaderFromBrowser() {
    return {
        authenticationSessionPayload: new Uint8Array(),
        arkoseToken: "",
        ssoClientId: "",
        continueParam: "",
    };
}
exports.WebLoginHeaderFromBrowser = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.authenticationSessionPayload.length !== 0) {
            writer.uint32(10).bytes(message.authenticationSessionPayload);
        }
        if (message.arkoseToken !== "") {
            writer.uint32(18).string(message.arkoseToken);
        }
        if (message.ssoClientId !== "") {
            writer.uint32(26).string(message.ssoClientId);
        }
        if (message.continueParam !== "") {
            writer.uint32(34).string(message.continueParam);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWebLoginHeaderFromBrowser();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.authenticationSessionPayload = reader.bytes();
                    break;
                case 2:
                    message.arkoseToken = reader.string();
                    break;
                case 3:
                    message.ssoClientId = reader.string();
                    break;
                case 4:
                    message.continueParam = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseWebLoginHeaderFromBrowser();
        message.authenticationSessionPayload =
            object.authenticationSessionPayload ?? new Uint8Array();
        message.arkoseToken = object.arkoseToken ?? "";
        message.ssoClientId = object.ssoClientId ?? "";
        message.continueParam = object.continueParam ?? "";
        return message;
    },
};
//# sourceMappingURL=web_login_common.js.map